import styled from "styled-components";

const StyledContainer = styled.div`
    display: flex;
    justify-content: center;
    align-items: center;
    height: 100vh;
    background-color: #8a0538;
`;

const StyledCardLogin = styled.div`
    max-width: 620px;
    max-height: 500px;
    background-color: #ffffff;
    box-shadow: 0px 4px 8px rgb(0 0 0 / 8%);
    border-radius: 16px;
    padding: 3em;
    margin: 1em;
`;

const StyledTitle = styled.h1`
    font-weight: 700;
    font-size: 30px;
    line-height: 40px;
    color: rgb(64, 64, 64);
    padding: 65px 30px 65px;
    margin: 0px;
    text-align: center;
`;

export { StyledContainer, StyledCardLogin, StyledTitle };
